<template>
  <!-- 一级路由 -->
  <router-view />

  <!-- sidebar -->
  <side-bar v-if="!(username === 'guest' || !username)" />
</template>

<script>
import SideBar from './components/app-sidebar'

export default {
  name: 'App',
  components: { SideBar },
  setup () {
    return {
      username: window.getUserName()
    }
  }
}
</script>
